import React from "react";
import { languages } from "../../constants/languages";
import resultsPicture from "../../img/results.png";
import Typography from "@material-ui/core/Typography";

const NoResultsMessage = props => (
  <div style={{ width: "95%", textAlign: "center", marginBottom: 20 }}>
    <div style={{ maxWidth: 700, display: "inline-block" }}>
      <img
        src={resultsPicture}
        alt=""
        style={{ height: 100, margin: "20px 0 15px 0" }}
      />
      <Typography variant="h6">
        {props.title ? props.title : languages.results.noResultsMessageTitle}
      </Typography>
      <Typography variant="subtitle1" style={{ fontSize: 17 }}>
        {languages.results.noResultsMessageDescription}
      </Typography>
    </div>
  </div>
);

export default NoResultsMessage;
